module.exports = __webpack_public_path__ + "media/images/header_icons/chat-ac378b60ff315ae897428cad4631dba2.svg";